import { useMediaQuery } from 'react-responsive';

const useImage = () => {
  const isSmallMobile = useMediaQuery({ maxWidth: 375 });
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });
  const isSmallLaptop = useMediaQuery({ maxWidth: 1200 });

  const cloudImageUrl = process.env.REACT_APP_CLOUDIMAGE_URL;

  const getWidthBySize = (widths) => {
    if (isSmallMobile && widths.smallMobile) return widths.smallMobile;
    if (isMobile && widths.mobile) return widths.mobile;
    if (isTablet && widths.tablet) return widths.tablet;
    if (isSmallLaptop && widths.smallLaptop) return widths.smallLaptop;

    return widths.default;
  };

  const getImageSrc = ({ fileId, widths }) => {
    if (!fileId || !cloudImageUrl) return '';
    const mediaUrl = new URL(`${cloudImageUrl}${fileId}`);

    if (widths?.default) {
      mediaUrl.searchParams.append('width', getWidthBySize(widths));
    }
    mediaUrl.searchParams.append('sharp', 1);

    return mediaUrl?.href || '';
  };

  return {
    getImageSrc,
  };
};

export default useImage;
